import Marionette from "../../shared/marionette-mustache";
import { ResultView } from "../../search/views/result";
import { ResultModel } from "../../search/models/result";
import { backboneViewProperties } from "../../decorators/backbone-properties";
import { ResultsCollection } from "../collections/results";
import {Container} from "aurelia-dependency-injection";
import {MobileHelper} from "../../shared/helpers/mobile-helper";

import "waypoints/lib/jquery.waypoints";

const dom = {
    RESULTS_LIST: ".results-list",
    RESULT_ITEMS: ".results-item"
};
@backboneViewProperties({
    tagName: "ul",
    className: "results-list",
    childView: ResultView
})
export class Results extends Marionette.CollectionView<ResultModel, ResultView> {

    private waypoint: any; // TODO figure out how to type these as Waypoint objects
    constructor(options?: Marionette.CollectionViewOptions<ResultModel>) {
        super(options);
        this.listenTo(this.collection, "add", this.setupMobileWayPoints);
        this.listenTo(this.collection, "render", this.render);
    }

    private setupMobileWayPoints(model): void {
        /*
         * DEVELOPER'S NOTE!!!
         *
         * Use this.$, as opposed to simply $ when accessing the results items in this class
         * Otherwise the results-item in the exact-result region will get picked up and cause nasty bugs
         */

        // Check we definitely want these waypoints
        const mh: MobileHelper = Container.instance.get(MobileHelper);
        if (!mh.IsMobileMode) {
            return;
        }
        if (!model || !model.isWaypoint) { // We flag the one we want to attach waypoint to in the search model
            return;
        }
        if (this.waypoint) { // If we already have a waypoint (i.e previous one hasn't triggered) we don't want a new one
            return;
        }

        const last = this.$(dom.RESULT_ITEMS + ":last");
        if (last.length === 0) {
            return; // in case there's no elements
        }
        const view = this;
        this.waypoint = last.waypoint({
            handler: function(direction) {
                if (direction === "down") {
                    (view.collection as ResultsCollection).requestMoreResults();
                    this.destroy(); // "this" is the waypoint - remove it once its triggered
                    view.waypoint = null;
                }
            },
            context: $("#standard-results-region").first(), // have to use this as opposed to results-list as the latter collapses to 0px height and won't trigger waypoints
            offset: "bottom-in-view"
        });

    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/results.ts